import { DataLayer } from "@grandvisionhq/analytics";
import { myAccountEventType } from "./types.js";
const logSignInEvent = () => {
  DataLayer.pushEvent({
    event_type: myAccountEventType,
    event: "sign_in_click"
  });
};
export {
  logSignInEvent
};
//# sourceMappingURL=sign-in.js.map
